import CryptoJS from 'crypto-js'

export default {
    // 加密
    encrypt(strOrignText) {
        var key = CryptoJS.enc.Utf8.parse('e92fb457d4374941');
        var iv = CryptoJS.enc.Utf8.parse('5fd403b9c0c04329');
        var encrypted = CryptoJS.AES.encrypt(strOrignText, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    // 解密
    decrypt(strEncryptText) {
        var key = CryptoJS.enc.Utf8.parse('e92fb457d4374941');
        var iv = CryptoJS.enc.Utf8.parse('5fd403b9c0c04329');
        var decrypted = CryptoJS.AES.decrypt(strEncryptText, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    },
    encrypt_aes(msg) {
        var ivSize = 128;       // IV長度        
        // 產生隨機字串
        var salt = CryptoJS.lib.WordArray.random(128 / 8);
        // 進行HmacSHA256加密產生KEY值
        var key = CryptoJS.HmacSHA256(salt.toString(), 'e92fb457d4374941');
        // 產生隨機IV
        var iv = CryptoJS.lib.WordArray.random(ivSize / 8);
        // 加密
        var encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });
        // 組合字串
        var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
        return transitmessage;
    },
    decrypt_aes(transitmessage) {
        // 取得密文中的salt
        var salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
        // 取得密文中的iv
        var iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32))
        // 取得密文本體
        var encrypted = transitmessage.substring(64);
        // 進行HmacSHA256加密產生KEY值
        var key = CryptoJS.HmacSHA256(salt.toString(), 'e92fb457d4374941');
        // 解密
        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        return decrypted.toString(CryptoJS.enc.Utf8);
    },
    getJWT(payload, key) {
        const header = JSON.stringify({
            alg: "HS256",
            typ: "JWT",
        });
        const headerBase64 = Buffer.from(header)
            .toString("base64")
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
        const payloadBase64 = Buffer.from(payload)
            .toString("base64")
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
        const signature = CryptoJS.HmacSHA256(headerBase64 + "." + payloadBase64, key).toString();
        const signatureBase64 = Buffer.from(signature, 'hex')
            .toString("base64")
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
        return headerBase64 + '.' + payloadBase64 + '.' + signatureBase64;
    }
}


// WEBPACK FOOTER //
// ./src/utils/aes.js